import { Map } from "../../models/Models";
import { PlanbyEventCollection } from "../../models/epg/Models";
import { uniq } from "lodash-es";

export const calculateEpgDates = (eventCollectionByDateByChannelTag: Map<PlanbyEventCollection[]> | undefined) => {
    let dates: string[] = [];

    Object.entries(eventCollectionByDateByChannelTag ?? {})
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([ channelTag, eventCollectionByDate ]) =>
            eventCollectionByDate.forEach((eventCollection) => dates.push(eventCollection.day))
        );

    dates = uniq(dates).sort();

    return dates;
};
